import { FuseLoadable } from "@fuse";

export const ClientViewConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: "/app/clientViewPanel/clientViewDashboard",
      component: FuseLoadable({
        loader: () => import("./ClientViewForm.js")
      })
    }
  ]
};
